import Vue from "vue"
import SvgIcon from "./SvgIcon"

Vue.component("SvgIcon", SvgIcon)
